import { useState } from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";

// Modal shown right after approval to display the manual-share activation link.
// Robust workaround for cases where the recipient's email provider (Apple
// iCloud, Outlook consumer) blocks our messages on new domains.
export function ActivationLinkDialog({ open, link, memberName, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch { toast.error("Não foi possível copiar o link."); }
  };
  const whatsapp = `https://wa.me/?text=${encodeURIComponent(`Olá ${memberName || ""}, o seu acesso ao CIEES Portugal está aprovado. Configure a sua palavra-passe aqui (válido 14 dias): ${link}`)}`;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-6" data-testid="activation-link-dialog">
      <div className="bg-white max-w-lg w-full p-8 border border-[hsl(var(--border))]">
        <div className="overline">Acesso aprovado</div>
        <h3 className="display-heading text-2xl mt-3">Partilhe o link com {memberName}.</h3>
        <span className="accent-rule mt-5 block" />
        <p className="mt-5 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
          Foi enviado um email de boas-vindas. Como alguns fornecedores de email (Apple, Outlook) podem demorar a aceitar emails do nosso domínio, este link garante o acesso. Partilhe por WhatsApp/SMS se necessário. Válido <strong>14 dias</strong>.
        </p>
        <div className="mt-5 bg-[hsl(var(--secondary))] p-3 border border-[hsl(var(--border))] text-xs font-mono break-all" data-testid="activation-link-value">
          {link}
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          <button onClick={copy} className="btn-primary" data-testid="activation-copy-button">
            <Copy className="h-4 w-4" /> {copied ? "Copiado ✓" : "Copiar link"}
          </button>
          <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="btn-outline" data-testid="activation-whatsapp-button">
            <span style={{ fontSize: 14 }}>💬</span> Enviar WhatsApp
          </a>
          <button onClick={onClose} className="ml-auto text-xs uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]" data-testid="activation-close-button">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
